import React, { useEffect } from 'react';
import { useBlocker } from 'react-router-dom';
import { useDispatch } from 'react-redux';

export const useUnsavedChanges = (hasUnsavedChanges: boolean) => {
  const dispatch = useDispatch();

  useBlocker(() => {
    if (hasUnsavedChanges) {
      const confirmLeave = window.confirm(
        'Вы уверены, что хотите покинуть страницу без сохранения внесенных изменений?'
      );
      return !confirmLeave;
    }
    return false;
  });

  useEffect(() => {
    const handleBeforeUnload = (e: { preventDefault: () => void; returnValue: string }) => {
      if (hasUnsavedChanges) {
        e.preventDefault();
        e.returnValue = ''; // Browser-specific requirement
      }
    };

    if (hasUnsavedChanges) {
      window.addEventListener('beforeunload', handleBeforeUnload);
    }

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [hasUnsavedChanges]);
};
